import { Component, OnInit } from '@angular/core';
declare var jQuery:any;
declare var $:any;
import { CommonService } from '../../services/common.service';
import { RoutesService} from '../../services/routes.service';
import { RouteService} from '../../services/route.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HolidayCalendarService } from '../../services/holiday-calendar.service';
import swal from 'sweetalert2';




@Component({
  selector: 'app-holiday-calendar',
  templateUrl: './holiday-calendar.component.html',
  styleUrls: ['./holiday-calendar.component.css']
})
export class HolidayCalendarComponent implements OnInit {
	dataEvent: any;
	paramGlob: any = [];
  	constructor(
  		private commonService: CommonService,
  		private route: ActivatedRoute,
	    private router: Router,
	    private routesService: RoutesService,
	    private routeService: RouteService,
	    private holidayCalendarService: HolidayCalendarService,
  	) { }
	username : any = this.commonService.getUserName()

  	ngOnInit() {
	  	// this.getHolidaysByCompany();
	  	var dateNow = new Date();
		var year = dateNow.getFullYear();
		let that = this;
		console.log(this.dataEvent)

		console.log('ingresando a get')
	    this.holidayCalendarService.getHolidaysByCompany(this.commonService.getUserName())
	    .then(response => {
	      	var dataHolidays = []
	      	var dataHolString = ''
	      	var yearControlDate = 3;
	      	var yearIni = year - yearControlDate;
	      	var yearEnd = year + yearControlDate;
	      	var yearsForData = year + yearControlDate;
	      	for(let y = yearIni;y < yearEnd;y++){   	
		      	for (let n = 0; n < response.length; n++) {
		      		var jsonHoliday = {}
		      		var dayHol = (response[n]["day"]).toString();
		      		if(dayHol.length == 1){
		      			dayHol = '0' + dayHol
		      		}
		      		var monthHol = response[n]["month"].toString();
		      		if(monthHol.length == 1){
		      			monthHol = '0' + monthHol
		      		}
		      		var dateHol = y + '-' + monthHol + '-' + dayHol
		      		jsonHoliday["title"] = "DIA FESTIVO"
		      		jsonHoliday["description"] = "DIA FESTIVO desc"
		      		jsonHoliday["start"] = dateHol
		      		// var jsonString = JSON.stringify(jsonHoliday);
		      		var jsonString = jsonHoliday;
		      		dataHolidays.push(jsonString)
		      	}
		      }
	      	this.dataEvent = dataHolidays
	      	// console.log('dataEvent dataEvent dataEvent dataEvent : ', this.dataEvent)

			var today = Date.now()
			console.log(today)
		  	$('#calendar').fullCalendar({
		  		// themeSystem: 'jquery-ui',
		  		lang: 'es',
			  	defaultDate: today,
			  	navLinks: true,
			  	editable: true,
			  	eventLimit: true,
			  	events: dataHolidays,
			  	customButtons: {
				    addEventButton: {
			      		text: 'Add new event',
			      		click: function () {
			        		var dateStr = prompt('Enter date in YYYY-MM-DD format');
			        		//var date = moment(dateStr);
			        		var date = dateStr;
			        		// if (date.isValid()) {
			        		if (date) {
			          			$('#calendar').fullCalendar('renderEvent', {
			            			title: 'Evento Dinamico',
			            			start: date,
			            			allDay: true
			          			});
			        		} else {
			          			alert('Dato invalido');
			        		}
			        	}
			    	}
		 	 	},
		 	 	eventClick: function(calEvent, jsEvent, view)
		        {
            		$('#calendar').fullCalendar('removeEvents', calEvent._id);
  					// that.deleteHoliday('param');
                  	//console.log('gdhhjl')
                  	var dateSplit = calEvent.start._i.split('-')
               		var dateMonth = dateSplit[1]
               		//console.log('dateMonth : ', dateMonth)
			    	var dateDay = dateSplit[2]
			    	//console.log('dateDay : ', dateDay)
		      		let param = {
			      		"User_account":that.username,
		      			"Month": dateMonth,
		      			"Day": dateDay,
		      		};
                  	that.holidayCalendarService.deleteHolidays(param).then(response =>{
            			if(response){
			    			swal({
				    			title: "Se ha borrado esta fecha como dia festivo.",
		                  		text: '',
		                  		type: 'warning'
		                	}).catch(swal.noop);
    					}
    				});
    				console.log('saliendo del llamado')
         		},
		 	 	/*
			  	eventClick: function(calEvent, jsEvent, view) {
			  		let that = this;
			  		swal({
			  			title: 'Esta fecha ya esta marcada como dia festivo, ¿La desea eliminar?',
	                	text: '',
	                	type: 'warning',
	                	showCancelButton: true,
	                	confirmButtonColor: '#3085d6',
	                	cancelButtonColor: '#d33',
	                	confirmButtonText: 'Sí',
	                	cancelButtonText: 'No'
		            }).then(function (s) {
                		if(s.dismiss !== undefined){
	                		if (s.dismiss.toString() === 'cancel') {
	                     	}
	                   	}
	                   	else{
	                   		if(s.value!== undefined){
	                   			if(s.value){
			                   		var dateSplit = calEvent.start._i.split('-')
			                   		var dateMonth = dateSplit[1]
			                   		console.log('dateMonth : ', dateMonth)
							    	var dateDay = dateSplit[2]
							    	console.log('dateDay : ', dateDay)
						      		let param = {
							      		"User_account":that.username,
						      			"Month": dateMonth,
						      			"Day": dateDay,
						      		};
						      		console.log('llamando servicio ')
						      		$('#calendar').fullCalendar('removeEvents', calEvent._id);
						      		that.deleteHoliday(param)
		                			that.holidayCalendarService.deleteHolidays(param).then(response =>{
			                			if(response){
							    			swal({
								    			title: "Se ha borrado esta fecha como dia festivo.",
						                  		text: '',
						                  		type: 'warning'
						                	}).catch(swal.noop);
			        					}
			        				});
			        				console.log('saliendo del llamado')
		                		}
		                	}
	        			}
					}).catch(swal.noop);
				},
				*/
				dayClick: function (date, start, end, jsEvent, view, resource, event) {
				  	var dateValidate =  date.format('YYYY-MM-DD').toString()
				    let swValidateDate = 0;
					for (let d of that.dataEvent) {
					  	if(dateValidate == d.start){
					  		swValidateDate = 1;
					  		break;
					  }
					}
				    // var date = moment(date.format('MM-DD-YYYY'));
				    var dateSplit = (date.format('MM-DD-YYYY').toString()).split('-')
				    var dateMonth = dateSplit[0]
				    var dateDay = dateSplit[1]
				    var dateYear = dateSplit[2]

			      	let param = {
			      		"User_account":that.commonService.getUserName(),
			      		"Month": dateMonth,
			      		"Day": dateDay,
			      	};
				    if (swValidateDate == 0) {
					    that.holidayCalendarService.saveHolidays(param).then(response =>{
					    	if(response){
					    		$('#calendar').fullCalendar('renderEvent', {
					    			title: 'DIA FESTIVO',
							        start: date,
							        allDay: true
							    });

					    		that.holidayCalendarService.getHolidaysByCompany(that.commonService.getUserName())
							    .then(response => {
							      	var dataHolidays = []
							      	var dataHolString = ''
							      	var yearControlDate = 3;
							      	var yearIni = year - yearControlDate;
							      	var yearEnd = year + yearControlDate;
							      	var yearsForData = year + yearControlDate;
							      	for(let y = yearIni;y < yearEnd;y++){    	
								      	for (let n = 0; n < response.length; n++) {
								      		var jsonHoliday = {}
								      		var dayHol = (response[n]["day"]).toString();
								      		if(dayHol.length == 1){
								      			dayHol = '0' + dayHol
								      		}
								      		var monthHol = response[n]["month"].toString();
								      		if(monthHol.length == 1){
								      			monthHol = '0' + monthHol
								      		}
								      		var dateHol = y + '-' + monthHol + '-' + dayHol
								      		jsonHoliday["title"] = "DIA FESTIVO"
								      		jsonHoliday["description"] = "DIA FESTIVO desc"
								      		jsonHoliday["start"] = dateHol
								      		var jsonString = jsonHoliday;
								      		dataHolidays.push(jsonString)
								      	}
							      	}
							      	that.dataEvent = dataHolidays
					    		});
						    }
							else{
								console.log('no se pudo guardar el elemento,comunicate con el administrador')
							}
						});	
					}
				}
			});		  
		});
	}

	deleteHoliday(param):void{
		console.log('param : ', param)

	}
}




/*
  getHolidaysByCompany(): void {
  	console.log('ingresando a get')
    this.holidayCalendarService.getHolidaysByCompany(this.commonService.getUserName())
    .then(response => {
      	console.log('response  : ', response)
      	var dataHolidays = []
      	var dataHolString = ''
      	for (let n = 0; n < response.length; n++) {
      		var jsonHoliday = {}

      		var dayHol = response[n]["day"];
      		var monthHol = response[n]["month"];
      		console.log('dia : : : : ', dayHol)
      		console.log('mes : : : : ', monthHol)

      		var dateHol = '2019-' + monthHol + '-' + dayHol
      		console.log('dateHol : ', dateHol)

      		jsonHoliday["title"] = "DIA FESTIVO"
      		jsonHoliday["description"] = "DIA FESTIVO desc"
      		jsonHoliday["start"] = dateHol
      		var jsonString = JSON.stringify(jsonHoliday);
      		dataHolidays.push(jsonString.toString())

      	}
      	console.log(dataHolidays)
      	var daH = '[' + dataHolidays.toString() + ']'
      	console.log('dah : ', daH)
      	this.dataEvent = daH
      

	  	$('#calendar').fullCalendar({
	      	defaultDate: '2019-12-01',
	      	navLinks: true,
		  	editable: true,
			eventLimit: true,
			// events: [{ title: 'Festivo', start: '2019-12-04',   description: 'Super cool event' },{ title: 'Festivo 5', start: '2019-12-05',   description: 'Super cool event' } ],
			// events: daH,
			events: [{'title':'DIA FESTIVO','description':'DIA FESTIVO desc','start':'2019-12-21'},{'title':'DIA FESTIVO','description':'DIA FESTIVO desc','start':'2019-12-23'},{'title':'DIA FESTIVO','description':'DIA FESTIVO desc','start':'2019-12-31'},{'title':'DIA FESTIVO','description':'DIA FESTIVO desc','start':'2019-12-31'},{'title':'DIA FESTIVO','description':'DIA FESTIVO desc','start':'2019-12-18'}],
			customButtons: {
				addEventButton: {
			    	text: 'Add new event',
			      	click: function () {
			        	var dateStr = prompt('Enter date in YYYY-MM-DD format');
			        	var date = moment(dateStr);
			        	console.log('date dinamic : ', date)
			        	console.log('date dinamic .isValid(): ', date.isValid())
			        	console.log(moment().format('MM-DD-YYYY'))
			        	if (date.isValid()) {
			          		$('#calendar').fullCalendar('renderEvent', {
			            		title: 'Evento Dinamico',
			            		start: date,
			            		allDay: true
			          		});
			        	} else {
			          		alert('Dato invalido');
			        	}

			      	}
		    	}
			},
	      	});
	    });

    
	}
*/


// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/holiday-calendar/holiday-calendar.component.ts